export enum WarehouseLocalityStatus {
  SYNCHRONIZED = 'SYNCHRONIZED',
  NOT_SYNCHRONIZED = 'NOT_SYNCHRONIZED',
  NOT_ON_MARKETPLACE = 'NOT_ON_MARKETPLACE',
  NOT_IMPORTED = 'NOT_IMPORTED',
}

export interface WarehouseLocality {
  id?: number;
  code?: string;
  city?: string;
  countryCode?: string;
  postcode?: string;
  province?: string;
  street?: string;
  houseNumber?: string;
  email?: string;
  name?: string;
  company?: string;
  phone?: string;
  expeditionShiftByDPlus?: number;
  maxHandlingTime?: number;
  lastFullImport?: string;
  isDefault?: boolean;
  isFullImportRunning?: boolean;
  lastFullImportProducts?: number;
  lastFullImportProductCodes?: string;
  fullImportFailedMessage?: string;
  status?: WarehouseLocalityStatus;
}

export interface WarehouseLocalitySave {
  marketplaceCode: string;
  code?: string;
  name?: string;
  company?: string;
  email?: string;
  street?: string;
  houseNumber?: string;
  city?: string;
  postcode?: string;
  countryCode?: string;
  province?: string;
  phone?: string;
  isDefault?: boolean;
  expeditionShiftByDPlus?: number;
  maxHandlingTime?: number;
}

export interface WarehouseSynchronizationResult {
  savedWarehouseLocalities: WarehouseLocality[],
  notDeletedWarehouseLocalities: {
    warehouseLocality: WarehouseLocality,
    numberOfAssignedProducts: number
  }[]
}

export interface AssignedProducts {
  warehouseLocalityId: number;
  numberOfProducts: number;
}
